import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
var ExitIcon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "0.813rem",
        height: "0.813rem",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "Exit Icon"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M0.5 13.5L13.5 0.5M13.5 13.5L0.5 0.5",
                stroke: "#333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
export default /*#__PURE__*/ memo(ExitIcon);
